import type { FeatureDefinition } from '../../definition/FeatureDefinition';
import type { FeatureEditSession } from '../../edit/FeatureEditSession';

/**
 * 特征预览展示选项。
 */
export interface FeaturePreviewPresentationOptions {
    /** 预览引导优先绑定的选择项引用，仅影响气泡等展示语义。 */
    preferredItemRef?: string | null;
}

/**
 * 特征预览执行器抽象基类。
 */
export abstract class FeaturePreviewExecution<TDefinition extends FeatureDefinition = FeatureDefinition> {
    /**
     * 在创建态执行预览。
     *
     * @param definition 特征定义。
     * @param options 预览附加表达选项。
     * @returns 预览网格数据。
     */
    public abstract executeCreatePreview(
        definition: TDefinition,
        options?: FeaturePreviewPresentationOptions,
    ): Promise<WorkerFeaturePreviewResult>;

    /**
     * 在编辑态 sandbox 中执行预览。
     *
     * @param session 编辑会话。
     * @param definition 草稿定义。
     * @param options 预览附加表达选项。
     * @returns 预览网格数据。
     */
    public abstract executeEditPreview(
        session: FeatureEditSession<TDefinition>,
        definition: TDefinition,
        options?: FeaturePreviewPresentationOptions,
    ): Promise<WorkerFeaturePreviewResult>;
}
